/** @format */

import { environment } from "../env";

export function formatDate(value) {
  let date = new Date(value);
  let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let day = date.getDate();
  let monthIndex = date.getMonth();
  let monthName = monthNames[monthIndex];
  let year = date.getFullYear();
  return `${day}-${monthName}-${year}`;
}

export const questionTypeMapping = {
  "Range Type": "SLIDER",
  Checkbox: "CHECKBOX",
  "Radio Type": "RADIO_BUTTON",
};

export const ReverseQtypeMapping = {
  SLIDER: "Range Type",
  CHECKBOX: "Checkbox",
  RADIO_BUTTON: "Radio Type",
  "Range Type": "Range Type",
  Checkbox: "Checkbox",
  "Radio Type": "Radio Type",
};
export const upcomingPolls = [
  { id: 1, start_date: "2019-09-03", end_date: "2019-09-10" },
  { id: 2, start_date: "2019-09-11", end_date: "2019-09-18" },
  { id: 3, start_date: "2019-10-19", end_date: "2019-10-26" },
];
export const historyPolls = [
  {
    id: 1,
    start_date: "2019-01-03",
    end_date: "2019-01-10",
    questions: ["Question 1", " Question 2", " Question3"],
  },
  {
    id: 2,
    start_date: "2019-01-11",
    end_date: "2019-01-18",
    questions: ["Question1", "Question2", "Question3"],
  },
  {
    id: 3,
    start_date: "2019-01-19",
    end_date: "2019-01-26",
    questions: ["1Question", "2Question", "Question3"],
  },
  {
    id: 4,
    start_date: "2019-02-01",
    end_date: "2019-02-08",
    questions: ["1", "2", "3"],
  },
  { id: 5, start_date: "2019-03-03", end_date: "2019-03-10", questions: [] },
  { id: 6, start_date: "2019-04-15", end_date: "2019-04-22", questions: [] },
  { id: 7, start_date: "2019-05-13", end_date: "2019-05-20", questions: [] },
];

export const pollList = {
  startDate: "01/07/2020",
  endDate: "26/07/2020",

  questions: [
    {
      channel: ["Edible Oil"],
      totalCount: 110,
      options: [
        { optionText: "LA", count: 20 },
        { optionText: "PA", count: 10 },
        { optionText: "DA", count: 30 },
        { optionText: "FA", count: 50 },
      ],

      questionText: "What is the username?",
      questionType: "Checkbox",
      region: ["LA"],
    },

    {
      channel: ["Edible Oil"],
      totalCount: 75,
      options: [
        { optionText: "CSK", count: 20 },
        { optionText: "KKR", count: 10 },
        { optionText: "DC", count: 15 },
        { optionText: "SRH", count: 25 },
        { optionText: "MI", count: 5 },
      ],

      questionText: "Who will will the IPL 2020?",
      questionType: "Radio Type",
      region: ["Caribbean"],
    },

    {
      channel: ["Edible Oil"],
      options: [{ optionText: "30" }, { optionText: "40" }],

      questionText: "What will be the price of wheat?",
      questionType: "Range Type",
      region: ["SA"],
    },
  ],
};

export const sample_questionnaire = {
  title: "Investor Questionnaire",
  desc: "Answer these questions with one specific financial goal in mind, such as retirement. Don't use this questionnaire for goals that require you to spend all of your money for the goal within the next two years. Savings for short-term objectives should be invested in stable instruments—primarily short-term reserves.",
  questions: [
    {
      questionText: "I plan to begin taking money from my investments in ...",
      questionType: "Radio Type",
      optionText: "",
      edit: false,
      options: [
        { optionText: "2 years or less", optionCategory: "Category 1" },
        { optionText: "3-5 years", optionCategory: "Category 2" },
        { optionText: "More than 15 years", optionCategory: "Category 1" },
        { optionText: "11-15 years", optionCategory: "Category 2" },
        { optionText: "6-10 years", optionCategory: "Category 3" },
      ],
    },
    {
      questionText: "I plan to begin taking money from my investments in ...",
      questionType: "Radio Type",
      optionText: "",
      edit: false,
      options: [
        { optionText: "2 years or less", optionCategory: "Category 1" },
        { optionText: "3-5 years", optionCategory: "Category 2" },
        { optionText: "More than 15 years", optionCategory: "Category 1" },
        { optionText: "11-15 years", optionCategory: "Category 2" },
        { optionText: "6-10 years", optionCategory: "Category 3" },
      ],
    },
    {
      questionText: "I plan to begin taking money from my investments in ...",
      questionType: "Radio Type",
      optionText: "",
      edit: false,
      options: [
        { optionText: "2 years or less", optionCategory: "Category 1" },
        { optionText: "3-5 years", optionCategory: "Category 2" },
        { optionText: "More than 15 years", optionCategory: "Category 1" },
        { optionText: "11-15 years", optionCategory: "Category 2" },
        { optionText: "6-10 years", optionCategory: "Category 3" },
      ],
    },
  ],
};

export const api_key = environment.api_key;
export const C3_api_key = environment.C3_api_key;
export const STORAGE_API = "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1";
export const HISTORY_API = "https://ondemand.websol.barchart.com/getHistory.jsonp";
export const CHART_API = "https://ondemand.websol.barchart.com/getQuote.jsonp";

export const EUR_TO_USD = 1.14;
export const USD_TO_EUR = 0.88;

export const isObjectEmpty = (object) => {
  return Object.values(object).every((val) => val === "" || val === undefined || val === null);
};

export const ACTIVATION_CODE = "A";
export const DEACTIVATION_CODE = "D";
export const USER_STATUS = {
  NEW: "New",
  ACTIVE: "Active",
  DENIED: "Denied",
  REMOVED: "Removed",
  APPROVED: "Approved",
  PROVISIONED: "Provisioned",
  DEACTIVATION_PENDING: "Deactivation Pending",
  REACTIVATION_PENDING: "Reactivation Pending"
}

export const ROUTES = {
  login: "/login",
  loginLoading: "/LogInLoading",
  register: "/register",
  wildCard: "*"
}

export const KEYPRESS = {
  ENTER: "Enter"
}

export const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);
